import { CookieHelper } from './cookie-helper';

export class PersistentStore {

    cookieEnabled(): boolean {
        return navigator.cookieEnabled;
    }

    setItem(key: string, value: string, expiration: number): void {
        CookieHelper.writeLocalCookie(key, value, expiration);
    }

    getItem(key: string): string {
        return CookieHelper.read(key);
    }

    deleteItem(key: string): void {
        return CookieHelper.delete(key);
    }
}
